import { FC, ElementType } from "react";
import { StyledText } from "./style";
import { ColorProps, LayoutProps, SpaceProps, TypographyProps } from "../../../shared/styled";

interface IProps extends SpaceProps, ColorProps, TypographyProps, LayoutProps {
    as?: ElementType;
    className?: string;
}

const Text: FC<IProps> = ({ as, className, children, ...restProps }) => {
    return (
        <StyledText as={as} className={className} {...restProps}>
            {children}
        </StyledText>
    );
};

export default Text;
